import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import JobSearch from "@sourceflow-uk/job-search";
import imageMetaData from "../../.sourceflow/image_metadata.json";
import { Container, Row, Col } from "reactstrap";
import Link from "next/link";
import styles from "./styles.module.scss";
import Arrow from "/public/site-assets/svg/arrow.svg";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { motion, useTransform, useScroll } from "framer-motion";
import md5 from "md5";
import Helmet from "react-helmet";
import { useEffect } from "react";
import BreadCrumb from "../../components/Shared/BreadCrumb";

export default function MainBanner({
  global,
  pathPrefix,
  customClass = "",
  content,
  imageURL1,
  imageURL2,
  imageALT1,
  imageALT2,
  jobSearch = false,
  displayImage1 = true,
  pageAnchor = false,
  editableContent = true,
  locale = "https://www.carbon60global.com",
  breadcrumb_title,
  secondary_breadcrumb_url,
  secondary_breadcrumb_title,
  buttonLink = false,
  buttonTitle,
  post,
  buttonLink2,
  buttonTitle2,
  buttonLink3,
  buttonTitle3,
  ctaLink = null,
  ctaTitle = null,
  featured_logo,
  featured_employers_job_cta,
}) {
  // Function to format the date
  // const formatDate = (dateString) => {
  //     const date = new Date(dateString);
  //     const options = { day: 'numeric', month: 'long', year: 'numeric' };
  //     return date.toLocaleDateString('en-US', options);
  // };

  const variants_1 = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.05 } },
  };
  const variants_2 = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.2 } },
  };
  return (
    <section
      className={`${styles.root} ${customClass} position-relative ${
        displayImage1 ? null : "hidden-image-1"
      }`}
    >
      <Helmet>{imageURL2 && <link rel="prefetch" href={imageURL2} />}</Helmet>
      <Container>
        <Row className={`m-0 justify-content-between`}>
          <Col
            lg={6}
            className="contentWrapper d-flex flex-column justify-content-center  position-relative"
          >
            <div className={`position-relative wrapper mb-4 w-100`}>
              {breadcrumb_title && (
                <BreadCrumb
                  title={
                    <>
                      {secondary_breadcrumb_url && (
                        <span>
                          <Link href={secondary_breadcrumb_url}>
                            <a>{secondary_breadcrumb_title}</a>
                          </Link>
                        </span>
                      )}

                      <span className="active">{breadcrumb_title}</span>
                    </>
                  }
                  className={`py-2`}
                />
              )}
            </div>
            <div>
              {/* <motion.div
                initial="hidden"
                animate="visible"
                variants={variants_1}
              > */}
              {buttonLink && (
                <Link href={buttonLink}>
                  <a className="return-text text-nowrap arrow-left d-inline-flex align-items-center white mb-4">
                    <strong>{buttonTitle}</strong>
                  </a>
                </Link>
              )}
              {post?.tag?.length >= 1 && (
                <div className="d-flex justify-content-between mb-4 align-items-center">
                  <div>
                    {post?.tag?.map((post, index) => (
                      <span className="tag me-1" key={index}>
                        {post}
                      </span>
                    ))}
                  </div>
                  {/* {post.date && (
                                    <div className="post-date">{formatDate(post.date)}</div>
                                )} */}
                </div>
              )}
              {featured_logo ? (
                <>
                  <div className="d-flex gap-4 flex-wrap flex-lg-nowrap">
                    <div>
                      <SourceFlowImage
                        src={
                          post?.logo_image
                            ? post.logo_image
                            : "/site-assets/placeholders/img-placeholder.jpg"
                        }
                        size="350x"
                        alt={post.title}
                        className="logo"
                      />
                    </div>
                    <div>
                      {editableContent ? (
                        <SourceFlowText
                          global={global}
                          path={`${pathPrefix}.content`}
                          type="html"
                        >
                          {content}
                        </SourceFlowText>
                      ) : (
                        content
                      )}
                      {post?.banner_subtitle && (
                        <div className="mt-4">{post.banner_subtitle}</div>
                      )}
                      {buttonLink3 && (
                        <div className=" mt-4">
                          <a
                            className="primaryBtn no-arrow m-0 outline"
                            href={buttonLink3}
                          >
                            {buttonTitle3}
                          </a>
                        </div>
                      )}
                      {post?.banner_button_new_tab ? (
                        <div className="mt-4">
                          <Link href={`${post?.banner_button_link}`}>
                            <a
                              className="primaryBtn no-arrow outline"
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              {post?.banner_button_title}
                            </a>
                          </Link>
                        </div>
                      ) : (
                        <>
                          {post?.banner_button_link ? (
                            <div className="mt-4">
                              <Link href={`${post?.banner_button_link}`}>
                                <a className="primaryBtn no-arrow outline">
                                  {post?.banner_button_title}
                                </a>
                              </Link>
                            </div>
                          ) : null}
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {editableContent ? (
                    <SourceFlowText
                      global={global}
                      path={`${pathPrefix}.content`}
                      type="html"
                    >
                      {content}
                    </SourceFlowText>
                  ) : (
                    content
                  )}
                  {post?.banner_subtitle && (
                    <div className="mt-4">{post.banner_subtitle}</div>
                  )}
                  {buttonLink3 && (
                    <div className=" mt-4">
                      <a
                        className="primaryBtn no-arrow m-0 outline"
                        onClick={() => {
                          const formElement =
                            document.getElementById("contactForm");
                          if (formElement) {
                            formElement.scrollIntoView({ behavior: "smooth" });
                            const yOffset = -100;
                            const y =
                              formElement.getBoundingClientRect().top +
                              window.scrollY +
                              yOffset;
                            window.scrollTo({ top: y, behavior: "smooth" });
                            setTimeout(() => {
                              window.history.replaceState(
                                null,
                                null,
                                window.location.pathname
                              );
                            }, 100);
                          }
                        }}
                      >
                        {buttonTitle3}
                      </a>
                    </div>
                  )}
                  {ctaLink && ctaTitle &&
                    <a href={ctaLink} className="tertiaryBtn no-arrow mt-3 mb-0" rel="noopener noreferrer">
                      {ctaTitle}
                    </a>
                  }
                </>
              )}

              {/* </motion.div> */}
              {jobSearch ? (
                // <motion.div
                //   initial="hidden"
                //   animate="visible"
                //   variants={variants_2}
                // >
                <JobSearch
                  options={{
                    searchResults: false,
                    searchFilters: false,
                    submitDestination: `${locale ? locale : ""}/jobs`,
                  }}
                  translations={{
                    "input.placeHolder": "Job Title or Keyword",
                  }}
                />
              ) : // </motion.div>
              null}
            </div>
          </Col>
          {buttonLink2 && (
            <div className="position-relative z-1 w-auto d-flex align-items-end secondary-button mb-5 mb-lg-0 px-0">
              <a className="primaryBtn no-arrow m-0" href={buttonLink2}>
                {buttonTitle2}
              </a>
            </div>
          )}
          {displayImage1 ? (
            <Col lg={6} className="position-relative mainImageWrapper">
              <SourceFlowImage
                src={
                  imageURL1
                    ? imageURL1
                    : "/site-assets/placeholders/img-placeholder.jpg"
                }
                path={`${pathPrefix ? pathPrefix : md5(imageURL1)}.image`}
                imagesMetaData={imageMetaData}
                size="413x448"
                alt={imageALT1}
                className="d-none d-md-block card-img rounded-4"
                loading={"eager"}
              />
            </Col>
          ) : null}
          <div className="imageWrapper position-absolute p-0">
            <SourceFlowImage
              src={
                imageURL2
                  ? imageURL2
                  : "/site-assets/placeholders/img-placeholder.jpg"
              }
              imagesMetaData={imageMetaData}
              path={`${pathPrefix ? pathPrefix : md5(imageURL2)}.image`}
              size="2000x"
              alt={imageALT2}
              className="card-img rounded-0"
              loading={"eager"}
            />
            {/* <img src={`${imageURL2}`} alt={`${imageALT2}`} className="card-img rounded-0"></img> */}
          </div>
        </Row>
        {pageAnchor ? (
          <AnchorLink
            offset="80"
            href={`#${pageAnchor}`}
            className="banner-anchor position-absolute"
            aria-label="Scroll Bottom"
          >
            <Arrow />
          </AnchorLink>
        ) : null}
      </Container>
    </section>
  );
}
